import { render, staticRenderFns } from "./xhmv2.vue?vue&type=template&id=71405a6a&"
import script from "./xhmv2.vue?vue&type=script&lang=js&"
export * from "./xhmv2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports